import React, { memo } from 'react';
import { Flex, Loading } from 'onefaceui-react-components';

import { useSelector } from 'react-redux';
import { getResourceTo } from 'react/utils/utils';

function MapLoadingOverlay() {
  const performingActionOnMap = useSelector(
    (state) => state.routeMonitor.performingActionOnMap
  );

  if (!performingActionOnMap) return null;

  return (
    <Flex dataTestId="loading-overlay" className="loading-overlay">
      <Loading isVisible message={getResourceTo('loading.message')} />
    </Flex>
  );
}

export default memo(MapLoadingOverlay);
